import config from "config/config.js";
import getFreshToken from "api/xsrfToken.js";

const updateUserImage = data => {
  const xsrfToken = getFreshToken();
  const endpoint = `${config.baseUrl}/api/user/photo`;
  const options = {
    method: "POST",
    mode: "cors",
    headers: {
      "Access-Control-Allow-Origin": "https://www.foodiestrip.com",
      "Access-Control-Allow-Credentials": true,
      Accept: "application/json",
      "Content-Type": "application/json",
      "X-XSRF-TOKEN": xsrfToken
    },
    credentials: "include",
    body: JSON.stringify(data)
  };
  return fetch(endpoint, options)
    .then(response => {
      return response.json();
    })
    .then(response => {
      // eslint-disable-next-line no-console
      // console.log(response);
      return response;
    })
    .catch(e => {
      // eslint-disable-next-line no-console
      console.log("errore", e);
    });
};

export default updateUserImage;
